import { Injectable } from '@angular/core';
import { QueryEntity, QueryConfig, Order } from '@datorama/akita';
import { Observable } from 'rxjs';
import { ChildStore, ChildState } from './child.store';
import { ChildViewModel } from './models/child-view.model';
import { PaymentOptionType } from '../account/membership-options/models/payment-option-type';
import { Guardian } from './models/guardian.model';

@Injectable({ providedIn: 'root' })
@QueryConfig({ sortBy: 'Id', sortByOrder: Order.ASC })
export class ChildQuery extends QueryEntity<ChildState> {

  isLoaded$: Observable<boolean> = this.select(state => state.loaded);
  
  constructor(protected store: ChildStore) {
    super(store);
  }

  /** Whether the current account is a guardian or not. */
  isGuardian(): boolean {
    return !!this.getValue().guardian;
  }

  /** Selects the current account's guardian or null if none exists */
  selectGuardian(): Observable<Guardian | undefined> {
    return this.select(childState => childState.guardian);
  }

  /** Gets the guardian ID of the current account. */
  getGuardianId(): number {
    return this.isGuardian() ? this.getValue().guardian!.Id : NaN;
  }

  /** All children. */
  selectChildren(): Observable<ChildViewModel[]> {
    return this.selectAll();
  }

  /** Children with free memberships. */
  selectFree(): Observable<ChildViewModel[]> {
    return this.selectAll({ filterBy: child => child.MembershipOption.PaymentType === PaymentOptionType.Free });
  }

  selectChildLimitCount(): number | undefined {
    return this.getValue().childLimit;
  }

  getChildrenInfo(): Observable<{ data: ChildViewModel[], free: ChildViewModel[], empty: any[], limit: number }>{
    return this.select(state => {
      const limit = state.childLimit || 0;
      const children = this.getAll(); 
      let empty = [];
      const len = limit - children.length;

      if( len > 0 ){
        empty = new Array(len);
      }
      
      return {
        data: children,
        free: children.filter((y) => y.MembershipOption.PaymentType === PaymentOptionType.Free),
        empty,
        limit
      }
    })
  }
}
